import { render, staticRenderFns } from "./twoPoem.vue?vue&type=template&id=07aad08f&scoped=true&"
import script from "./twoPoem.vue?vue&type=script&lang=js&"
export * from "./twoPoem.vue?vue&type=script&lang=js&"
import style0 from "./twoPoem.vue?vue&type=style&index=0&id=07aad08f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aad08f",
  null
  
)

export default component.exports